import { Component, HostListener, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { SidebarComponent } from '../sidebar/sidebar.component';
import { TopbarComponent } from '../topbar/topbar.component';
import { ShellNavService } from '../shell-nav.service';
import { AddressVerificationBannerComponent } from '../../address-verification-banner/address-verification-banner.component';

/**
 * Vendor (Professional Associate) application shell — CONNECT 2.0.
 *
 * Layout: persistent left sidebar rail + a right column made of the top strip
 * (<app-topbar>) over the routed content area (<router-outlet>) on --c-app-bg.
 *
 * Responsive: the rail is persistent >=900px. At <=900px it collapses to an
 * off-canvas drawer whose open/closed state lives in {@link ShellNavService};
 * a backdrop scrim, a backdrop click, and the ESC key all close it. The topbar
 * hamburger toggles it.
 *
 * The rail and topbar are `position: sticky`, and the content column flows in
 * the normal document — so the document (window) is the app's only scroll
 * container. That lets Angular's native `scrollPositionRestoration: 'enabled'`
 * (app.config.ts) scroll to top on forward navigations and restore scroll on
 * back navigations, with no custom scroll bookkeeping.
 */
@Component({
  selector: 'app-vendor-shell',
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    SidebarComponent,
    TopbarComponent,
    AddressVerificationBannerComponent,
  ],
  templateUrl: './vendor-shell.component.html',
  styleUrl: './vendor-shell.component.scss',
})
export class VendorShellComponent {
  protected readonly nav = inject(ShellNavService);

  /** ESC closes the drawer when it's open (no-op in persistent-rail mode). */
  @HostListener('document:keydown.escape')
  onEscape(): void {
    if (this.nav.drawerOpen()) {
      this.nav.close();
    }
  }
}
